module.exports = { apiServer: 'https://api.uat.web-system.hk', AdminServer: 'https://admin.uat.web-system.hk', env: 'prod' };
